import { ButtonConfig } from '@app/Modules/type';
import { Button } from '@mui/joy';
import { markAsProcessed } from '@app/api/data/potentiels-parrainages';

type ActionButtonsProps = {
    buttonConfig: ButtonConfig;
    id: string;
    onSuccess?: () => void;
};

const handleAction = async (
    action: string,
    apiUrl: string,
    id: string,
    onSuccess?: () => void
) => {
    switch (action) {
        case 'process':
            await markAsProcessed(id)
                .then(() => {
                    onSuccess && onSuccess();
                })
                .catch((err) => {
                    console.error('Error processing record:', err);
                });
            break;
        default:
            console.warn(`Action "${action}" not implemented`);
    }
};

const ActionButtons = ({ buttonConfig, id, onSuccess }: ActionButtonsProps) => {
    const { label, action, icon, color, apiUrl } = buttonConfig;

    return (
        <Button
            color={color as any}
            variant="soft"
            onClick={() => handleAction(action, apiUrl, id, onSuccess)}
        >
            {label}
        </Button>
    );
};

export default ActionButtons;
